import { useState } from 'react';

import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Popover from '@mui/material/Popover';
import Stack from '@mui/material/Stack';

import TakeAPhoto from '@webclient/components/search-forms/gamification-search/actions/file-attachment/sections/take-a-photo';
import UploadAFile from '@webclient/components/search-forms/gamification-search/actions/file-attachment/sections/upload-a-file';

import useAppDispatch from '@webclient/hooks/useAppDispatch';
import useAppSelector from '@webclient/hooks/useAppSelector';

import { setUploadedToKnowledgeBaseByUserId } from '@webclient/state/slices/app-settings';
import { selectShouldSaveUploadsToKnowledgeBase } from '@webclient/state/slices/app-settings/userSettingSelector';

import AttachmentRoundedIcon from '~icons/knowz-iconify/attachment-rounded';

//import SlidersRounded from '~icons/knowz-iconify/sliders';
import { Checkbox, IconButton } from '@knowz/knowz-ui';
import { useTranslate } from '@tolgee/react';

export default function FileAttachment() {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const dispatch = useAppDispatch();
  const me = useAppSelector((state) => state.auth.me);
  const open = Boolean(anchorEl);
  const { t } = useTranslate();
  const handleOpenPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const shouldSaveUploadsToKnowledgeBase = useAppSelector(
    selectShouldSaveUploadsToKnowledgeBase,
  );
  return (
    <>
      <IconButton
        onClick={handleOpenPopover}
        variant="ghost"
        color="secondary"
        size="small"
      >
        <AttachmentRoundedIcon />
      </IconButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        slotProps={{
          paper: {
            sx: {
              padding: 0,
            },
          },
        }}
        transformOrigin={{
          vertical: 180,
          horizontal: 88,
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <List disablePadding>
          <ListItem
            disableGutters
            disablePadding
            sx={{
              paddingX: 1.5,
              paddingY: 1.75,
            }}
          >
            <TakeAPhoto />
          </ListItem>
          <ListItem
            disableGutters
            disablePadding
            sx={{
              paddingX: 1.5,
              paddingBlockEnd: 1.75,
            }}
          >
            <UploadAFile />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <Stack
                direction="row"
                gap={8}
              >
                <FormControlLabel
                  value="kb_only"
                  slotProps={{
                    typography: {
                      variant: 'textSm',
                    },
                  }}
                  control={
                    <Checkbox
                      color="primary"
                      size="small"
                      onChange={(e) => {
                        if (!me) return;
                        dispatch(
                          setUploadedToKnowledgeBaseByUserId({
                            shouldSave: e.target.checked,
                            userId: me.uuid,
                          }),
                        );
                      }}
                      checked={shouldSaveUploadsToKnowledgeBase}
                    />
                  }
                  label={t(
                    'layout.searchWidget.keepInKnowledgeBase.label',
                    'Keep in knowledge base?',
                  )}
                />
                {/* <IconButton
                  variant="ghost"
                  size="small"
                  edge="end"
                > //TODO: will add it back once we implement it
                  <SlidersRounded />
                </IconButton> */}
              </Stack>
            </ListItemIcon>
          </ListItem>
        </List>
      </Popover>
    </>
  );
}
